import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CarouselImage {
  imgid: string;
  imgmasterid: string;
  imgcategoryid: string;
  imgurl: string;
}

export interface AppConfiguration {
  configid: string;
  configtype: string;
  configvalue: string;
}

export interface ContestantDetail {
  bbc_type: number;
  bbc_contestant_season: number;
  bbc_name: string;
  bbc_actual_name: string;
  bbc_profession: string;
  bbc_dob: string;
  bbc_age: number;
  bbc_currentweek_position: string;
  bbc_nomination_count: number;
  bbc_evicted_date?: string | null;
  bbc_entry_date?: string | null;
  bbc_tag?: string;
  bbc_about_contestant?: string;
  bbc_img_url: string;
  bbc_remarks?: string;
}

export interface PollQuestion {
  dp_pollid: string;
  dp_pnc_categoryid: string;
  dp_poll_question: string;
  dp_poll_startdatetime: string;
  dp_poll_enddatetime: string;
}

export interface PollOptionResponse {
  dpo_poll_optionid: string;
  dpo_pollid: string;
  dpo_options: string;
  dpo_optionorder: number;
}

export interface PollResponse {
  pollquestion: PollQuestion[];
  options: PollOptionResponse[];
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly pollsApiUrl = `${environment.apiUrl}/API/Polls/polls`;
  private readonly voteApiUrl = `${environment.apiUrl}/API/Polls/vote`;
  private readonly alreadyVotedApiUrl = `${environment.apiUrl}/API/Polls/alreadyvoted`;
  private readonly carouselImgApiUrl = `${environment.apiUrl}/API/BB/getcarousellimg`;
  private readonly configurationApiUrl = `${environment.apiUrl}/API/BB/getconfiguration`;
  private readonly contestantDetailsApiUrl = `${environment.apiUrl}/API/BB/BBcontestantDetails`;

  constructor(private http: HttpClient) { }

  getPoll(): Observable<PollResponse> {
    return this.http.post<PollResponse>(this.pollsApiUrl, { dp_isactive: 'Y' });
  }

  getCarouselImages(categoryId: string = 'IC2600002'): Observable<CarouselImage[]> {
    const payload = {
      pi_pnciid: categoryId
    };
    return this.http.post<CarouselImage[]>(this.carouselImgApiUrl, payload);
  }

  getConfiguration(configType: string = 'BB10_Header'): Observable<AppConfiguration[]> {
    const payload = {
      csc_config_type: configType
    };
    return this.http.post<AppConfiguration[]>(this.configurationApiUrl, payload);
  }

  getContestantDetails(season: number = 10): Observable<ContestantDetail[]> {
    const payload = {
      bbc_contestant_season: season
    };
    return this.http.post<ContestantDetail[]>(this.contestantDetailsApiUrl, payload);
  }

  submitVote(pollId: string, optionId: string, fingerprint: string): Observable<any> {
    const payload = {
      dpo_pollid: pollId,
      dpo_poll_optionid: optionId,
      dpo_fingerprint: fingerprint
    };
    return this.http.post<any>(this.voteApiUrl, payload);
  }

  getAlreadyVoted(pollId: string): Observable<any> {
    const payload = {
      dpo_pollid: pollId
    };
    return this.http.post<any>(this.alreadyVotedApiUrl, payload);
  }
}
